import { IconFunction } from '@ey-xd/ng-motif';
import {
  MotifActionIcAssignmentTurnedIn24px,
  MotifActionIcBookmark24px,
  MotifActionIcCheckCircle24px,
  MotifActionIcCode24px,
  MotifActionIcDashboard24px,
  MotifActionIcDateRange24px,
  MotifActionIcDelete24px,
  MotifActionIcDot24px,
  MotifActionIcExitToApp24px,
  MotifActionIcHistory24px,
  MotifActionIcHome24px,
  MotifActionIcInfo24px,
  MotifActionIcInfoOutline24px,
  MotifActionIcOpenInNew24px,
  MotifActionIcPlayForWork24px,
  MotifActionIcRestorePage24px,
  MotifActionIcSettingsBackupRestore24px,
  MotifActionIcSwapVerticalCircle24px,
  MotifAlertIcError24px,
  MotifAlertIcErrorOutline24px,
  MotifAlertIcWarning24px,
  MotifAvIcPauseCircleFilled24px,
  MotifAvIcPauseCircleOutline24px,
  MotifAvIcReplay24px,
  MotifCommunicationIcNoSim24px,
  MotifContentIcAdd24px,
  MotifContentIcContentCopy24px,
  MotifContentIcFilterList24px,
  MotifContentIcFlag24px,
  MotifContentIcRemoveCircle24px,
  MotifContentIcRemoveCircleOutline24px,
  MotifContentIcUndo24px,
  MotifEditorIcModeEdit24px,
  MotifFileIcCloudDownload24px,
  MotifFileIcFileDownload24px,
  MotifFileIcFileUpload24px,
  MotifHardwareIcKeyboardArrowDown24px,
  MotifHardwareIcKeyboardArrowLeft24px,
  MotifHardwareIcKeyboardArrowRight24px,
  MotifHardwareIcKeyboardArrowUp24px,
  MotifHardwareIcKeyboardBackspace24px,
  MotifHardwareIcKeyboardReturn24px,
  MotifHardwareIcSimCard24px,
  MotifImageIcRemoveRedEye24px,
  MotifImageIcTimer24px,
  MotifNavigationIcArrowDropDown24px,
  MotifNavigationIcArrowUpward24px,
  MotifNavigationIcCancel24px,
  MotifNavigationIcCheck24px,
  MotifNavigationIcClose24px,
  MotifNavigationIcExpandLess24px,
  MotifNavigationIcExpandMore24px,
  MotifNavigationIcMoreVert24px,
  MotifNavigationIcRefresh24px,
  MotifSocialIcGroupAdd24px,
  MotifSocialIcPeople24px,
} from '@ey-xd/motif-icon';

// Legacy motif material icons used to be served as static SVG files from
// `@ey-xd/motif-core`. Newer motif versions ship them only as icon functions in
// `@ey-xd/motif-icon`, so `<motif-icon [src]="/assets/icons/...">` 404s. Keys are
// the normalized legacy paths (see `normalizeIconPath`) mapped to the new functions.
export const MOTIF_ICON_FUNCTION_MAP: Record<string, IconFunction> = {
  'assets/icons/action/ic_assignment_turned_in_24px.svg': MotifActionIcAssignmentTurnedIn24px,
  'assets/icons/action/ic_bookmark_24px.svg': MotifActionIcBookmark24px,
  'assets/icons/action/ic_check_circle_24px.svg': MotifActionIcCheckCircle24px,
  'assets/icons/action/ic_code_24px.svg': MotifActionIcCode24px,
  'assets/icons/action/ic_dashboard_24px.svg': MotifActionIcDashboard24px,
  'assets/icons/action/ic_date_range_24px.svg': MotifActionIcDateRange24px,
  'assets/icons/action/ic_delete_24px.svg': MotifActionIcDelete24px,
  'assets/icons/action/ic_dot_24px.svg': MotifActionIcDot24px,
  'assets/icons/action/ic_exit_to_app_24px.svg': MotifActionIcExitToApp24px,
  'assets/icons/action/ic_history_24px.svg': MotifActionIcHistory24px,
  'assets/icons/action/ic_home_24px.svg': MotifActionIcHome24px,
  'assets/icons/action/ic_info_24px.svg': MotifActionIcInfo24px,
  'assets/icons/action/ic_info_outline_24px.svg': MotifActionIcInfoOutline24px,
  'assets/icons/action/ic_open_in_new_24px.svg': MotifActionIcOpenInNew24px,
  'assets/icons/action/ic_play_for_work_24px.svg': MotifActionIcPlayForWork24px,
  'assets/icons/action/ic_restore_page_24px.svg': MotifActionIcRestorePage24px,
  'assets/icons/action/ic_settings_backup_restore_24px.svg': MotifActionIcSettingsBackupRestore24px,
  'assets/icons/action/ic_swap_vertical_circle_24px.svg': MotifActionIcSwapVerticalCircle24px,
  'assets/icons/alert/ic_error_24px.svg': MotifAlertIcError24px,
  'assets/icons/alert/ic_error_outline_24px.svg': MotifAlertIcErrorOutline24px,
  'assets/icons/alert/ic_warning_24px.svg': MotifAlertIcWarning24px,
  'assets/icons/av/ic_pause_circle_filled_24px.svg': MotifAvIcPauseCircleFilled24px,
  'assets/icons/av/ic_pause_circle_outline_24px.svg': MotifAvIcPauseCircleOutline24px,
  'assets/icons/av/ic_replay_24px.svg': MotifAvIcReplay24px,
  'assets/icons/communication/ic_no_sim_24px.svg': MotifCommunicationIcNoSim24px,
  'assets/icons/content/ic_add_24px.svg': MotifContentIcAdd24px,
  'assets/icons/content/ic_content_copy_24px.svg': MotifContentIcContentCopy24px,
  'assets/icons/content/ic_filter_list_24px.svg': MotifContentIcFilterList24px,
  'assets/icons/content/ic_flag_24px.svg': MotifContentIcFlag24px,
  'assets/icons/content/ic_remove_circle_24px.svg': MotifContentIcRemoveCircle24px,
  'assets/icons/content/ic_remove_circle_outline_24px.svg': MotifContentIcRemoveCircleOutline24px,
  'assets/icons/content/ic_undo_24px.svg': MotifContentIcUndo24px,
  'assets/icons/editor/ic_mode_edit_24px.svg': MotifEditorIcModeEdit24px,
  'assets/icons/file/ic_cloud_download_24px.svg': MotifFileIcCloudDownload24px,
  'assets/icons/file/ic_file_download_24px.svg': MotifFileIcFileDownload24px,
  'assets/icons/file/ic_file_upload_24px.svg': MotifFileIcFileUpload24px,
  'assets/icons/hardware/ic_keyboard_arrow_down_24px.svg': MotifHardwareIcKeyboardArrowDown24px,
  'assets/icons/hardware/ic_keyboard_arrow_left_24px.svg': MotifHardwareIcKeyboardArrowLeft24px,
  'assets/icons/hardware/ic_keyboard_arrow_right_24px.svg': MotifHardwareIcKeyboardArrowRight24px,
  'assets/icons/hardware/ic_keyboard_arrow_up_24px.svg': MotifHardwareIcKeyboardArrowUp24px,
  'assets/icons/hardware/ic_keyboard_backspace_24px.svg': MotifHardwareIcKeyboardBackspace24px,
  'assets/icons/hardware/ic_keyboard_return_24px.svg': MotifHardwareIcKeyboardReturn24px,
  'assets/icons/hardware/ic_sim_card_24px.svg': MotifHardwareIcSimCard24px,
  'assets/icons/image/ic_remove_red_eye_24px.svg': MotifImageIcRemoveRedEye24px,
  'assets/icons/image/ic_timer_24px.svg': MotifImageIcTimer24px,
  'assets/icons/navigation/ic_arrow_drop_down_24px.svg': MotifNavigationIcArrowDropDown24px,
  'assets/icons/navigation/ic_arrow_upward_24px.svg': MotifNavigationIcArrowUpward24px,
  'assets/icons/navigation/ic_cancel_24px.svg': MotifNavigationIcCancel24px,
  'assets/icons/navigation/ic_check_24px.svg': MotifNavigationIcCheck24px,
  'assets/icons/navigation/ic_close_24px.svg': MotifNavigationIcClose24px,
  'assets/icons/navigation/ic_expand_less_24px.svg': MotifNavigationIcExpandLess24px,
  'assets/icons/navigation/ic_expand_more_24px.svg': MotifNavigationIcExpandMore24px,
  'assets/icons/navigation/ic_more_vert_24px.svg': MotifNavigationIcMoreVert24px,
  'assets/icons/navigation/ic_refresh_24px.svg': MotifNavigationIcRefresh24px,
  'assets/icons/social/ic_group_add_24px.svg': MotifSocialIcGroupAdd24px,
  'assets/icons/social/ic_people_24px.svg': MotifSocialIcPeople24px,
};

// Legacy paths appear as `/assets/...`, `./assets/...` and `assets/...`; strip the
// leading `/` or `./` so every variant resolves to the same map key.
export function normalizeIconPath(path: string): string {
  return path.replace(/^(?:\.\/|\/)/, '');
}
